import React, { useState, useEffect } from "react";
import Routers from "./Routers";
import Nav from "./Nav";
import { themes, themsField } from "@/config/config";
import { Select, Row, Col } from "antd";
import UserPanel from "./UserPanel";
import { useLocation } from "react-router-dom";

const Component = (props: any) => {
  const { setCurTheme } = props;
  // const useLocations: any = useLocation();
  const changeTheme = (e: any) => {
    setCurTheme(e);
    localStorage.setItem(themsField, e);
  };

  return (
    <>

      {/* {useLocations.pathname === "/main" ? (
        ""
      ) : (
        <Row>
          <Col span={24}>
            <div className="pageTopBar">
              <Nav />
              <UserPanel />
            </div>
          </Col>
        </Row>
      )} */}
      {/* */}
    {/* <Row>
        <Col span={24}>
          <div className="pageTopBar">
            <Nav />
            <UserPanel />
          </div>
        </Col>
        <Col span={2}>
          <Select onChange={changeTheme} defaultValue={localStorage.getItem('MPPTheme') ? localStorage.getItem('MPPTheme') : 'light' as any}>
            {themes.map((item: any) => {
              return (
                <Select.Option value={item.code} key={item.code}>
                  {item.name}
                </Select.Option>
              );

            })}
          </Select>
        </Col>
      </Row>  */}

      <Routers />
    </>
  );
};

export default Component;
